import { Component, OnInit } from '@angular/core';
import { AppConfig } from 'app/app.config';

@Component({
  selector: 'Teranet-ContactUsDialog',
  templateUrl: './contact-us-dialog.component.html'
})

export class ContactUsDialogComponent implements OnInit {
  phoneNumber: number;
  emailGeneralQuestion: string;
  emailSalesMarket: string;
  ngOnInit() {
    this.emailGeneralQuestion = AppConfig.settings.settings.Email_General_Question;
    this.emailSalesMarket = AppConfig.settings.settings.Email_Sales_Market;
  }
}
